import { call, put, takeLatest } from "redux-saga/effects";
import { authApi } from "../../../api/auth/authApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IAccountLoginStart, IAuthGetUserStart, eAuthAcitonTypes } from "../../action-types/auth/IAuthActions";
import { actions } from "../../actions";

export function* authSaga(): any {
    yield takeLatest(eAuthAcitonTypes.GET_USER_START, getDetailWorker)
    yield takeLatest(eAuthAcitonTypes.LOGIN_START, logInWorker)

}

function* getDetailWorker(action: IAuthGetUserStart): any {
    const res: IBaseRespone = yield call([authApi, authApi.getUser])
    if (res.is_success) {
        yield put(actions.auth.getUserSuccss(res.data))
    } else {
        yield put(actions.auth.getUserError(res.message))
    }
}

function* logInWorker(action: IAccountLoginStart): any {
    const res: IBaseRespone = yield call(authApi.logIn, action.payload)
    if (res.is_success) {
        yield put(actions.auth.loginSuccess(res.data))
    } else {
        yield put(actions.auth.loginError(res.message ?? ""))
    }
}